import { StickerTexte } from '@components/sticker-texte/models';
import { Block } from '@shared/models';

const withoutCtaMock: StickerTexte = {
  title: "Chez SoCoo'c, 100% de nos meubles sont made in France, garantis 10 ans et livrés chez vous déjà montés",
  sticker: {
    svg: { svg: '/assets/tmp/store.svg' },
    rotation: 'right',
  },
};

const withCtaMock: StickerTexte = {
  title: 'Pas de surprise à la caisse ! Estimez votre budget cuisine en fonction de vos envies.',
  sticker: {
    svg: { svg: '/assets/tmp/store.svg' },
    rotation: 'left',
  },
  cta: {
    label: "J'estime mon budget",
    url: '/mock-estimateur-budget',
  },
  isCentered: true,
};

export const stickerTexteMock = (withCta = false): Block<StickerTexte> => ({
  type: 'sticker-texte',
  data: withCta ? withCtaMock : withoutCtaMock,
});
